import { Merchant } from "breadcommon";
import { DefaultTransactionColumnValue } from "./DefaultTransactionColumnValue";
import { MerchantLogo } from "../common/MerchantLogo";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumn } from "./TransactionColumn";
import { buildClasses } from "../utils/buildClasses";
import { useContext } from "react";
import { TransactionRowContext } from "./TransactionRow";
import { RyeTooltip } from "../rye/RyeTooltip";

export function TransactionColumnValueMerchant({
  merchant,
}: {
  merchant: Merchant | null;
}): JSX.Element {
  const { ruleForFieldHighlighting } = useContext(TransactionRowContext);

  if (merchant !== null) {
    return (
      <TransactionColumnSizer column={TransactionColumn.MERCHANT}>
        <DefaultTransactionColumnValue
          ruleHighlight={
            ruleForFieldHighlighting.get !== null &&
            ruleForFieldHighlighting.get.criteria.merchant_name !== null
          }
        >
          <MerchantLogo merchant={merchant} size={18.5}></MerchantLogo>
          <RyeTooltip text={merchant.name}>
            <div
              className={buildClasses(
                "w-100",
                "pl-3",
                "whitespace-nowrap",
                "overflow-hidden",
                "overflow-ellipsis",
              )}
            >
              {merchant.name}
            </div>
          </RyeTooltip>
        </DefaultTransactionColumnValue>
      </TransactionColumnSizer>
    );
  }

  return <TransactionColumnSizer column={TransactionColumn.MERCHANT} />;
}
